import { useRecoilState, useRecoilValue } from "recoil"
import useHttpLoader from "shared/hooks/useHttpLoader"
import projectTypesSelectors from "../projectTypes.selectors"
import { useEffect } from "react"
import projectTypesAtom from "../projectTypes.atom"
import projectTypesApi from "../projectTypes.api"

const useProjectTypesState = () => {
  const [projectTypesState, setProjectTypesState] = useRecoilState(projectTypesAtom)
  const projectTypesMap = useRecoilValue(projectTypesSelectors.projectTypesMap)

  const { wait, loading } = useHttpLoader()

  const fetcher = () => {
    return projectTypesApi.getAll()
  }
  useEffect(() => {
    wait(fetcher(), (resp) => {
      if (resp.status === 'success') {
        setProjectTypesState(() => ({
          items: resp.body
        }))
      }
    })
  }, [])
  
  return { projectTypesState, setProjectTypesState, projectTypesMap, loading}
}

export default useProjectTypesState